export const normalizeSavedCard = (card = {}) => {
  const masked = String(card.maskedCardNumber || '');
  const digits = masked.replace(/\D/g, '');
  return {
    id: card.id || card.cardId,
    name: card.cardHolderName || card.name || 'Card Holder',
    last4: card.last4 || card.lastFour || digits.slice(-4) || '****',
    cardType: card.cardType || card.brand || 'CARD',
    expiryMonth: card.expiryMonth,
    expiryYear: card.expiryYear,
    tokenId: card.razorpayTokenId || card.tokenId
  };
};

export const maskCardNumber = (last4) => `**** **** **** ${last4 || '****'}`;
